<template>
     <vs-dialog prevent-close v-model="active" width="800px">
        <template #header>
          <h4 class="not-margin">
              Alumnos con envío de correo no entregado
          </h4>
        </template>
        <div class="con-form" v-if="alumnosSinRegistro">
            <h6 class="mb-3">Te compartimos la lista de alumno(s) a los que no se logró enviar el correo exitosamente. <strong>El envío al resto de los alumnos fue realizado con éxito.</strong></h6>
            <div v-for="(persona, p) in alumnosSinRegistro" :key="p">
                <p class="mb-0"><small>NOMBRE: </small><strong>{{persona.full_name}}</strong></p>
                <p class="mb-0"><small>CORREO: </small><strong>{{persona.correo}}</strong></p>
                <hr>
            </div>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="active = false">
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import reportes from '../../../../../api/requests/reportes.js'
export default {
    props:[
      'value',
      'alumnosSinRegistro'
    ],
    data () {
        return {
            active: false,
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>
<style scoped>

.dividerLine {
  width: 100%;
  border-bottom: 1px solid #ddd
}
</style>